import { gql } from '@apollo/client';

export const VALIDATE_PASSWORD_REQUEST_TOKEN = gql`
  mutation VALIDATE_PASSWORD_REQUEST_TOKEN($token: String!) {
    validatePasswordResetToken(token: $token) {
      email
    }
  }
`;
